import React from "react";
import { Bar } from "react-chartjs-2";
import { SummaryText } from "../Text";

interface CostBenefitGraphProps {
  data: {
    summaries: {
      totalCostArray: number[];
      totalBenefitArray: number[];
      netProfitArray: number[];
      maxYears: number;
    }[];
  };
}

const CostBenefitGraph: React.FC<CostBenefitGraphProps> = ({ data }) => {
  let totalCostsData = data?.summaries[0]?.totalCostArray;
  let totalBenefitsData = data?.summaries[0]?.totalBenefitArray;
  let netBenefitData = data?.summaries[0]?.netProfitArray;

  let formatCurrency = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

  // Create labels for the x-axis
  const labels: string[] = [];
  for (let i = 0; i < data?.summaries[0]?.maxYears; i++) {
    labels[i] = "Year " + (i + 1);
  }

  const cumulativeCashFlowData = {
    labels: labels,
    datasets: [
      {
        label: `${SummaryText.financials.totalCosts}`,
        data: totalCostsData,
        backgroundColor: "#339cff", // blue
      },
      {
        label: `${SummaryText.financials.totalBenefits}`,
        data: totalBenefitsData,
        backgroundColor: "#E48030", // UDig-orange
      },
      {
        label: `${SummaryText.financials.netProfit}`,
        data: netBenefitData,
        backgroundColor: "#4C4C4C", // UDig-gray
      },
    ],
  };

  return (
    <div className="flex justify-center items-center my-8 w-auto bg-white rounded-md shadow-md print:shadow-none p-6 relative h-full chart-container">
      <Bar
        data={cumulativeCashFlowData}
        options={{
          maintainAspectRatio: true,
          responsive: true,
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              ticks: {
                callback: function (value: any) {
                  return formatCurrency.format(value);
                },
              },
              grace: 1,
            },
          },
        }}
      />
    </div>
  );
};

export default CostBenefitGraph;
